import { z } from 'zod'

/**
 * Where a vendor's video or audio link points. Linked, never uploaded. Mirrors
 * the Prisma `VendorMediaKind` enum (`check:enums`).
 */
export const VENDOR_MEDIA_KINDS = ['youtube', 'vimeo', 'soundcloud'] as const

export const vendorMediaKindSchema = z.enum(VENDOR_MEDIA_KINDS)

export type VendorMediaKind = z.infer<typeof vendorMediaKindSchema>

export const VENDOR_MEDIA_KIND_LABELS: Record<VendorMediaKind, string> = {
  youtube: 'YouTube',
  vimeo: 'Vimeo',
  soundcloud: 'SoundCloud',
}
